import moment from 'moment';
import MainCard from 'components/MainCard';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

export function PdfTable({ header = [], headerKeys = [], history = [] }) {
	return (
		<>
			<MainCard content={false} sx={{ overflow: 'hidden', width: '100%', height: '100%', mt: 2, borderColor: '#526375' }}>
				<TableContainer
					sx={{
						width: '100%',
						height: '100%',
						display: 'block',
						overflowX: 'auto',
						position: 'relative',
						'& td, & th': { whiteSpace: 'nowrap' },
					}}
				>
					<Table stickyHeader sx={{ '& th:not(:last-of-type)': { borderRight: 1, borderColor: 'common.white' } }}>
						<TableHead>
							<TableRow>
								{header.map((header, index) => (
									<TableCell key={header} sx={{ width: index === 0 ? '80px' : index === 1 ? '250px' : '200px' }}>
										{header}
									</TableCell>
								))}
							</TableRow>
						</TableHead>

						<TableBody>
							{history?.map((row, parentIndex) => (
								<TableRow key={parentIndex} sx={{ cursor: 'pointer', '&:hover': { background: '#f3f3f3' } }}>
									<TableCell>{parentIndex + 1}</TableCell>
									<TableCell>{moment(row?.dateTime?.localDateTimeString)?.format('DD MMMM YYYY hh:mm A')}</TableCell>

									{headerKeys.map((key, index) => (
										<TableCell
											key={index}
											sx={{
												color:
													parentIndex === 0
														? '#000'
														: history?.[parentIndex - 1]?.data?.[key] === row?.data?.[key]
															? '#000'
															: 'rgb(0, 0, 255)',
											}}
										>
											{moment(row?.data?.[key], moment.ISO_8601, true).isValid()
												? moment(row?.data?.[key])?.format('YYYY-MM-DD')
												: row?.data?.[key]}
										</TableCell>
									))}

									<TableCell
										sx={{
											color:
												parentIndex === 0
													? '#000'
													: history?.[parentIndex - 1]?.approverUserId === row?.approverUserId
														? '#000'
														: 'rgb(0, 0, 255)',
										}}
									>
										{row?.approverUserId?.toString() ?? '-'}
									</TableCell>

									{/* <TableCell
										sx={{
											color:
												parentIndex === 0
													? '#000'
													: history?.[parentIndex - 1]?.parkAction === row?.parkAction
														? '#000'
														: 'rgb(0, 0, 255)',
										}}
									>
										{row?.parkAction ? row?.parkAction : '-'}
									</TableCell> */}

									<TableCell
										sx={{
											color:
												parentIndex === 0
													? '#000'
													: history?.[parentIndex - 1]?.activationStatus === row?.activationStatus
														? '#000'
														: 'rgb(0, 0, 255)',
										}}
									>
										{row?.activationStatus ? row?.activationStatus : 'Null'}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</MainCard>
		</>
	);
}
